export {
  AccessibleIcon,
  //
  Root,
} from './AccessibleIcon';
export type { AccessibleIconProps } from './AccessibleIcon';
